








import TabLayout from "@/layouts/TabLayout.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReference, Reference } from "@/models/reference.entity";
import { IReport } from "@/models/report.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import PartnerMessageTable from "../../PartnerMessageTable.vue";

@Component({
  components: {
    TabLayout,
    PartnerMessageTable
  },
  filters: {}
})
export default class PartnerReportDetailMessage extends mixins(PermissionMixin) {
  @Ref("messageTable")
  messageTable!: PartnerMessageTable;

  @Prop()
  report!: IReport;

  isLoading = false;

  get ref(): IReference {
    return new Reference({ refId: this.report.id, refType: BackendResourceEnum.REPORT });
  }
}
